/**
 * Next.js <Link> does not have a disable possibility.
 * We extend the next.js' <Link> and name it A (comes from <a>)
 */
import classNames from 'classnames';
import Link, { LinkProps } from 'next/link';
import { forwardRef, HTMLProps, RefObject } from 'react';

const A = forwardRef((props: LinkProps & HTMLProps<HTMLAnchorElement>, ref: RefObject<HTMLAnchorElement>) => {
  const { href, as, children, className, disabled, replace, shallow, passHref, prefetch, scroll } = props;

  // If "href" or "as" missing
  if (!href || !as) {
    return (
      <a ref={ref} href={href || as} {...props}>
        {children}
      </a>
    );
  }

  // If disabled, return link without href
  if (disabled) {
    return (
      <a ref={ref} className={classNames(className, 'disabled')} {...props}>
        {children}
      </a>
    );
  }

  // Remove href from <a> props, <Link> handles it
  const aProps = { ...props };

  if (aProps.href) {
    delete aProps.href;
    // @ts-ignore Ignore warning about no classname existing.
    delete aProps.classname;
  }

  return (
    <Link
      href={href}
      as={as}
      replace={replace}
      scroll={scroll}
      shallow={shallow}
      passHref={passHref}
      prefetch={prefetch}
      ref={ref}
      {...(aProps as LinkProps)}
    >
      {children}
    </Link>
  );
});

export default A;
